import React from 'react';

import style from './index.scss';

const AdditionalInformationItems = ({ data, isCollapsed }) => {
  if (!isCollapsed) {
    if (data) {
      const { hits = [] } = data;

      if (Array.isArray(hits) && hits.length > 0) {
        // Get row header labels from first hit item
        const additionalItemsRowHeader = hits[0].additionalInformation;

        // loop row headers together with contents
        return additionalItemsRowHeader.map((rowHeaderItem, idx) => {
          // loop through hits
          const hitDataCells = hits.map((currentHit) => {
            const additionalInformationItem = currentHit.additionalInformation;

            if (additionalInformationItem) {
              return (
                <td>
                  {additionalInformationItem[idx]?.featureValue &&
                  String(additionalInformationItem[idx].featureValue)
                    .trim()
                    .toUpperCase() !== 'NAN'
                    ? additionalInformationItem[idx].featureValue
                    : '-'}
                </td>
              );
            }
          });

          // pour cells onto row
          return (
            <tr>
              <td>{rowHeaderItem.name}</td>
              <td></td>
              {hitDataCells}
            </tr>
          );
        });
      }

      return null;
    }
  }

  return null;
};

const AdditionalInformationSection = ({
  data,
  isCollapsed,
  onToggleCollapseState
}) => {
  if (data) {
    let collapsedClass = 'fa fa-angle-down';
    if (!isCollapsed) {
      collapsedClass = 'fa fa-angle-up';
    }

    return [
      <tr className={style.collapsibleRow}>
        <td colSpan="100%">
          <p>
            <i onClick={onToggleCollapseState} className={collapsedClass}></i>
            <b>Additional Information</b>
          </p>
        </td>
      </tr>,
      <AdditionalInformationItems data={data} isCollapsed={isCollapsed} />
    ];
  }

  return null;
};

export default AdditionalInformationSection;
